import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '../Modal';

const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const errorHandler = (error) => {
      console.error('Error caught by error boundary:', error);
      setHasError(true);
    };

    window.addEventListener('error', errorHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
    };
  }, []);

  const handleOk = () => {
    window.location.href = "/";
  }

  if (hasError) {
    // Fallback UI for the error
    return (
      <Modal isOpen={hasError}>
        <div className='somrthing-wrong'>
                Something went wrong. Please try again later.
                <button onClick={handleOk}>Ok</button>
        </div>
      </Modal>
    )
  }

  return children;
};

export default ErrorBoundary;